import { Link } from 'react-router-dom';

import { PageLevel } from '@/components/PageContainer';
import PageHeader from '@/components/PageContainer/PageHeader';
import { useI18nContext } from '@/i18n/I18n';

export const SubAccountApiMgtBreadcrumb = () => {
  const [$t] = useI18nContext();
  return (
    <PageHeader
      pageLevel={PageLevel.sub}
      breadItems={[
        {
          key: 'child.accountNew',
          label: () => (
            <Link to="/app/user/sub-account">{$t('child.accountNew')}</Link>
          ),
        },
        {
          key: 'TrustedDeviceMgmt',
          title: $t('subAccountApiManagement'),
        },
      ]}
    />
  );
};
